// extracted by mini-css-extract-plugin
export default {"btnsRow":"styles_btnsRow__YYu9t","main":"styles_main__tjY23","extra":"styles_extra__LalsV","separator":"styles_separator__KlfeF"};